@layer components {
  /* Co-located keyframes — Vite 8 / Lightning CSS scoping rule */
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  .skeleton {
    display: block;
    background-color: var(--surface-bg-tertiary);
    background-image: linear-gradient(
      90deg,
      transparent,
      color-mix(in oklch, var(--surface-bg-tertiary), white 15%),
      transparent
    );
    background-size: 200% 100%;
    animation: shimmer 2s infinite linear;
    border-radius: var(--radius-md);
    user-select: none;
    -webkit-user-select: none;
  }

  .skeleton[data-variant='text'] {
    height: 1.1em;
    width: 100%;
    margin-bottom: var(--spacing-2);
  }

  .skeleton[data-variant='circular'] {
    border-radius: var(--radius-full);
  }

  .skeleton[data-variant='rectangular'] {
    /* Base style is already rectangular with radius-md */
  }

  @media (prefers-reduced-motion: reduce) {
    .skeleton {
      animation: none;
      background-image: none;
    }
  }
}
